import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { Conversation } from '../../../services/conversation';
import { AuthService } from '../../../services/auth';
import { Router } from '@angular/router';
import { PermissionDeniedDialogComponent } from '../../permission-denied-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-data-table',
  standalone: true,
  imports: [
    CommonModule, FormsModule, MatTableModule, MatPaginatorModule,
    MatSortModule, MatInputModule, MatFormFieldModule, MatSelectModule,
    MatButtonModule, MatIconModule
  ],
  providers: [DatePipe],
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss']
})
export class DataTableComponent implements OnChanges {
  @Input() globalStartDate!: Date;
  @Input() globalEndDate!: Date;

  displayedColumns: string[] = ['date', 'phone', 'category', 'outcome', 'actions'];
  dataSource = new MatTableDataSource<any>([]);

  user;
  
  // Unique values for dropdown filters
  categories: string[] = [];
  outcomes: string[] = ['Satisfied', 'Not Satisfied', 'Indifferent'];
  
  // Filter values
  filterValues = {
    category: '',
    outcome: '',
    search: ''
  };

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private authService: AuthService,private router: Router,private conversationService: Conversation,private dialog: MatDialog) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['globalStartDate'] || changes['globalEndDate']) {
      this.loadRawData();
    }
  }

  loadRawData() {
    const start = this.globalStartDate.toISOString().split('T')[0];
    const end = this.globalEndDate.toISOString().split('T')[0];

    this.conversationService.getRawDataExplorer(start, end).subscribe(res => {
      this.dataSource.data = res.data || [];
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    //   console.log(res.data)
      
      // Extract unique categories for the dropdown
      this.categories = [...new Set(this.dataSource.data.map(item => item.conversation_category))];
      this.setupFilter();
    });

      this.authService.user$.subscribe(user=>{
    if(user){
      this.user = user;
    }
   })
  }

  setupFilter() {
    this.dataSource.filterPredicate = (data, filter: string) => {
      const searchTerms = JSON.parse(filter);
      const categoryMatch = data.conversation_category.toLowerCase().includes(searchTerms.category.toLowerCase());
      const outcomeMatch = data.interaction_outcome.toLowerCase().includes(searchTerms.outcome.toLowerCase());
      const searchMatch = data.conversation_id.toLowerCase().includes(searchTerms.search.toLowerCase());
      
      return categoryMatch && outcomeMatch && searchMatch;
    };
  }

  applyDropdownFilter() {
    this.dataSource.filter = JSON.stringify(this.filterValues);
  }

  downloadCSV() {
    const data = this.dataSource.filteredData;
    const headers = ['Date', 'Phone Number', 'Category', 'Outcome'];
    const csv = [
      headers.join(','),
      ...data.map(r => `${r.conversation_date.value},${r.conversation_id},${r.conversation_category},${r.interaction_outcome}`)
    ].join('\n');

    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `raw_data_export.csv`;
    a.click();
  }



  async viewRecordDetails(row: any) {
    let conversationId = row.conversation_id
    console.log('Navigating to transcript for:', conversationId);
    // Add router navigation here: this.router.navigate(['/transcript', id]);
      const tokenResult = await this.user.getIdTokenResult();
        const allowView = tokenResult.claims.view_convos === true||tokenResult.claims.admin === true;
        // console.log(tokenResult.claims)
         if (!allowView) {
            // Show modal
            const dialogRef = this.dialog.open(PermissionDeniedDialogComponent, {
              width: '400px',
              disableClose: true, // Prevent escape/click-out
              autoFocus: true
            });
    
            // Wait for user to click OK
            await dialogRef.afterClosed().toPromise();
    
          } else {
             this.router.navigate(['/conversation', conversationId]);
          }
  }

}